import { styled } from "@mui/system";
import { Menu } from "react-admin";
export const MenuItem = styled(Menu.Item)({
    whiteSpace: "normal"
});
